import React, { useMemo } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as V4ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import validate from 'validate.js';

import { chartjs } from './helpers';
import theme from './theme';
import { createTheme as createV2Theme, defaultConfig as defaultV2Config } from './theme_v2';
import useV2ThemeSettings from './theme_v2/use-theme-settings';
import palette from './theme/palette';
import typography from './theme/typography';

import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';

import validators from './common/validators';
import StoreContainer from './config/StoreContainer';
import Toast from './views/Toast';
import Loader from './views/Loader';

// 🔥 ROTAS
import Routes from './routes'; // V1
import RoutesV2 from './routes/v2.routes'; // V2

const browserHistory = createBrowserHistory();

// 🔧 MUI V4 CONFIG
const v4Overrides = (theme.components && theme.components.v4Overrides) || {};
const v4Props = (theme.components && theme.components.v4Props) || {};

const v4Theme = createMuiTheme({
  palette,
  typography,
  overrides: v4Overrides,
  props: v4Props
});

// 📊 ChartJS override
Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

// ✅ Validators
validate.validators = {
  ...validate.validators,
  ...validators
};

function App() {
  const { modeSetting, resolvedMode, setModeSetting } = useV2ThemeSettings();
  const themeV2 = useMemo(
    () => createV2Theme({
      ...defaultV2Config,
      paletteMode: resolvedMode,
    }),
    [resolvedMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <V4ThemeProvider theme={v4Theme}>
        <StoreContainer>
          <Loader />
          <Toast />

          {/* 🔥 CORRETO */}
          <Router history={browserHistory}>
            <Switch>
              
              {/* ===================== */}
              {/* Redirects para V2    */}
              {/* ===================== */}
              <Route exact path="/" render={() => <Redirect to="/v2/login" />} />
              <Route exact path="/login" render={() => <Redirect to="/v2/login" />} />

              {/* ===================== */}
              {/* 🚀 NOVO SISTEMA (V2) */}
              {/* ===================== */}
              <Route
                path="/v2"
                render={routeProps => (
                  <ThemeProvider theme={themeV2}>
                    <CssBaseline />
                    <RoutesV2
                      {...routeProps}
                      modeSetting={modeSetting}
                      resolvedMode={resolvedMode}
                      onModeSettingChange={setModeSetting}
                    />
                  </ThemeProvider>
                )}
              />
              {/* ===================== */}
              {/* 🧱 SISTEMA LEGADO */}
              {/* ===================== */}
              <Route path="/" component={Routes} />

            </Switch>
          </Router>

        </StoreContainer>
      </V4ThemeProvider>
    </ThemeProvider>
  );
}

export default App;